import { collection, collection2, commentscollection, temascollection } from '../directories/collections';
import { db, storage,  } from '../firebase/firebase';
import { loadContenido } from '../reducer/ContenidoReducer';

const getIntroduccion = async (email, idAsignatura, idTema) => {
    const data = [];
    await db.collection('Aula').doc(email)
        .collection('Subjects').doc(idAsignatura)
        .collection('topics').doc(idTema).collection('Introduction').get()
        .then((query) => {
            query.forEach((doc) => {
                data.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
        })
    return data
}

const getSeccion1 = async (email, idAsignatura, idTema) => {
    const data = [];
    await db.collection('Aula').doc(email)
        .collection('Subjects').doc(idAsignatura)
        .collection('topics').doc(idTema).collection('Seccion1').get()
        .then((query) => {
            query.forEach((doc) => {
                data.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
        })
    return data
}

const getSeccion2 = async (email, idAsignatura, idTema) => {
    const data = [];
    await db.collection('Aula').doc(email)
        .collection('Subjects').doc(idAsignatura)
        .collection('topics').doc(idTema).collection('Seccion2').get()
        .then((query) => {
            query.forEach((doc) => {
                data.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
        })
    return data
}

const getSeccion3 = async (email, idAsignatura, idTema) => {
    const data = [];
    await db.collection('Aula').doc(email)
        .collection('Subjects').doc(idAsignatura)
        .collection('topics').doc(idTema).collection('Seccion3').get()
        .then((query) => {
            query.forEach((doc) => {
                data.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
        })
    return data
}


const getSeccion4 = async (email, idAsignatura, idTema) => {
    const data = [];
    await db.collection('Aula').doc(email)
        .collection('Subjects').doc(idAsignatura)
        .collection('topics').doc(idTema).collection('Seccion4').get()
        .then((query) => {
            query.forEach((doc) => {
                data.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
        })

    return data
}

const getSeccion5 = async (email, idAsignatura, idTema) => {
    const data = [];
    const response = await db.collection('Aula').doc(email)
        .collection('Subjects').doc(idAsignatura)
        .collection('topics').doc(idTema).collection('Seccion5').get();
    response.forEach(query => {
        data.push({
            id: query.id,
            ...query.data()
        })
    })

    return data;
}



export const handleLoadContenido = (email,idAsig,idTema) => {
    const intro = [];
    const secU = [];
    const secD = [];
    const secT = [];
    const secC = [];
    const secQ = [];
    return async dispatch => {
        await getIntroduccion(email,idAsig,idTema).then(response => intro.push({...response[0]}))
        await getSeccion1(email,idAsig,idTema).then(response => secU.push({...response[0]}))
        await getSeccion2(email,idAsig,idTema).then(response => secD.push({...response[0]}))
        await getSeccion3(email,idAsig,idTema).then(response => secT.push({...response[0]}))
        await getSeccion4(email,idAsig,idTema).then(response => secC.push({...response[0]}))
        await getSeccion5(email,idAsig,idTema).then(response => secQ.push(response))
        dispatch(loadContenido(intro[0],secU[0],secD[0],secT[0],secC[0],secQ[0]))
    }
}

export const updateIntroduccion = async (email, idAsignatura, idTema, idSeccion, descripcion) => {
    return await db.collection('Aula').doc(email)
        .collection('Subjects').doc(idAsignatura)
        .collection('topics').doc(idTema)
        .collection('Introduction').doc(idSeccion).update({
            description: descripcion
        })
}



export const seleccionarPhoto = async (image, email, idAsignatura, idTema, idSeccion) => {
    if (image.type === undefined) {
        console.log("Error")
        return
    }
    if (image.type === "image/jpeg" || image.type === 'image/png') {
        try {

            const imagenRef = await storage.ref().child('Aula').child('Curso').child(email)
                .child(idAsignatura).child(idTema).child(idSeccion)
            await imagenRef.put(image)
            const imagenURL = await imagenRef.getDownloadURL()

            await db.collection('Aula').doc(email)
                .collection('Subjects').doc(idAsignatura)
                .collection('topics').doc(idTema)
                .collection('Introduction').doc(idSeccion).update({
                    picture: imagenURL
                })
        } catch (error) {
            console.log(error);
        }
    }
}


export const setSeccionTitle = async (email, idAsignatura, idTema, seccionColeccion, idSeccion, title) => {
    return await db.collection(collection).doc(email)
        .collection(collection2).doc(idAsignatura)
        .collection(temascollection).doc(idTema)
        .collection(seccionColeccion).doc(idSeccion).update({
            content: true,
            title: title
        })
}


export const setSeccionVideo = async (email, idAsignatura, idTema, seccionColeccion, idSeccion, video) => {
    return await db.collection(collection).doc(email)
        .collection(collection2).doc(idAsignatura)
        .collection(temascollection).doc(idTema)
        .collection(seccionColeccion).doc(idSeccion).update({
            content: true,
            video: video
        })
}

export const setSeccionPicture = async (email, idAsignatura, idTema, seccionColeccion, idSeccion, picture) => {
    if (picture.type === undefined) {
        console.log("Error");
        return
    }

    if (picture.type === "image/jpeg" || picture.type === 'image/png') {
        try {
            const imagenRef = await storage.ref().child('Aula').child('Curso').child(email).child(idAsignatura)
            .child(idSeccion)
            await imagenRef.put(picture)
            const imagenURL = await imagenRef.getDownloadURL()
            await db.collection(collection).doc(email)
                .collection(collection2).doc(idAsignatura)
                .collection(temascollection).doc(idTema)
                .collection(seccionColeccion).doc(idSeccion).update({
                    content: true,
                    picture: imagenURL
                })
        } catch (error) {
            console.log(error);
        }
    }

}


export const setSeccionDescripcion = async (email, idAsignatura, idTema, seccionColeccion, idSeccion, description) => {
    return await db.collection(collection).doc(email)
        .collection(collection2).doc(idAsignatura)
        .collection(temascollection).doc(idTema)
        .collection(seccionColeccion).doc(idSeccion).update({
            content: true,
            description: description
        })
}

export const setSeccionLink = async (email, idAsignatura, idTema, seccionColeccion, idSeccion, link) => {
    return await db.collection(collection).doc(email)
        .collection(collection2).doc(idAsignatura)
        .collection(temascollection).doc(idTema)
        .collection(seccionColeccion).doc(idSeccion).update({
            content: true,
            link: link
        })
}


export const setTitleEnlace = async (email, idAsignatura, idTema, seccionColeccion, idSeccion, title) => {
    return await db.collection(collection).doc(email)
        .collection(collection2).doc(idAsignatura)
        .collection(temascollection).doc(idTema)
        .collection(seccionColeccion).doc(idSeccion).update({
            content:true,
            title: title
        })
}

export const setEnlaceUno = async (email, idAsignatura, idTema, seccionColeccion, idSeccion, link1,namelink1) => {
    return await db.collection(collection).doc(email)
        .collection(collection2).doc(idAsignatura)
        .collection(temascollection).doc(idTema)
        .collection(seccionColeccion).doc(idSeccion).update({
            content:true,
            link1: link1,
            namelink1: namelink1

        })
}


export const setEnlaceDos = async (email, idAsignatura, idTema, seccionColeccion, idSeccion, link2,namelink2) => {
    return await db.collection(collection).doc(email)
        .collection(collection2).doc(idAsignatura)
        .collection(temascollection).doc(idTema)
        .collection(seccionColeccion).doc(idSeccion).update({
            content:true,
            link2: link2,
            namelink2: namelink2

        })
}




export const delQuestion = async (email, idAsig,idTema,idQuestion) => {
    return db.collection(collection).doc(email)
    .collection(collection2).doc(idAsig).collection(temascollection)
    .doc(idTema).collection('Seccion5').doc(idQuestion).delete()
}


export const addQuestion = async (email,IdAsig,idTema, newQuestion) => {
    return await db.collection(collection).doc(email)
    .collection(collection2).doc(IdAsig).collection(temascollection)
    .doc(idTema).collection('Seccion5').add({
        question: newQuestion
    })
}

export const updateQuestion = async (email,IdAsig, idTema,idQuestion, newquestion) => {
    return await db.collection(collection).doc(email)
    .collection(collection2).doc(IdAsig).collection(temascollection)
    .doc(idTema).collection('Seccion5').doc(idQuestion).update({
        question: newquestion
    })
}

export const CantComments = async (email,idAsignatura,question) => {
    let cantidad = 0;
    await db.collection(collection).doc(email)
    .collection(collection2).doc(idAsignatura)
    .collection(commentscollection).where("question","==", question).get()
    .then(query => {
        query.forEach(() => {
            cantidad++;
        })
    })
    return cantidad
}
